export default {
  noDataFound: '数据为空',
  loading: '加载中',
  createTime: '创建时间',
  done: '成功',
  fail: '失败',
  processing: '计算中',
  brand: '品牌',
  submit: '提交',
  // 公共文本
  'commons.labels.username': '登录名',
  'commons.labels.password': '密码',
  'commons.labels.selectSite': '请选择服务站点',
  'commons.buttons.login': '登录',
  'commons.buttons.confirm': '确定',
  'commons.buttons.cancel': '取消',
  'commons.buttons.modify': '修改',
  'commons.buttons.delete': '删除',
};
